import { render, staticRenderFns } from "./EdgeText.vue?vue&type=template&id=6d428a24&scoped=true&"
import script from "./EdgeText.vue?vue&type=script&lang=ts&"
export * from "./EdgeText.vue?vue&type=script&lang=ts&"
import style0 from "./EdgeText.vue?vue&type=style&index=0&id=6d428a24&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d428a24",
  null
  
)

export default component.exports